import React, { Fragment } from 'react'
import { useHowItWorks, HowItWorksProps } from './useHowItWorks'
import styles from './HowItWorks.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import StepItem from 'components/StepItem/StepItem'
import PricingModal from 'components/Modal/PricingModal/PricingModal'

const HowItWorks: React.FC<HowItWorksProps> = (props: HowItWorksProps) => {
  const {
    steps,
    showModal,
    selectedPlan,
    setShowModal,
    handleStartClick,
    handlePlanChange,
  } = useHowItWorks(props)

  return (
    <Fragment>
      <section id='how-it-works' className={styles['how-it-works']}>
        <TitleSection
          title='How It Works'
          descriptionTitle='How It Works'
          description='Launch your digital restaurant menu in minutes — no tech skills needed.'
        />

        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div className={styles['steps-content']}>
                <h2>Our Seamless Menu Setup Process</h2>
                <p className={styles.lead}>
                  From sign-up to serving — we’ve simplified everything.
                </p>
                <p>
                  Create and launch a stunning, mobile-friendly menu that
                  updates in real time and elevates the dining experience.
                </p>
                <p>
                  Say goodbye to clunky PDFs and complicated systems. With
                  ByteBuffetBox, you’re minutes away from a sleek, digital menu
                  your guests will love — no tech skills required.
                </p>

                <div className={styles['steps-cta']}>
                  <button
                    type='button'
                    className={`btn ${styles['btn-primary']}`}
                    onClick={(e) => {
                      e.preventDefault()
                      handleStartClick()
                    }}
                  >
                    Start Free
                  </button>
                  <a href='/demo' className={`btn ${styles['btn-outline']}`}>
                    View Live Demo
                  </a>
                </div>
              </div>
            </div>

            <div className='col-lg-6'>
              <div className={styles['steps-list']}>
                {steps.length ? (
                  steps.map((step, i) => (
                    <StepItem
                      key={`step-${step.number}-${i}`}
                      number={step.number}
                      title={step.title}
                      description={step.description}
                    />
                  ))
                ) : (
                  <div style={{ color: 'var(--footer-color)' }}>
                    Nothing Found Here!
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <PricingModal
          title='Choose Your Plan'
          plan={selectedPlan}
          setShowModal={setShowModal}
          handlePlanChange={handlePlanChange}
        />
      )}
    </Fragment>
  )
}

export default HowItWorks
